import { IconButton, Tooltip, Typography } from "@mui/material";
import { FaDirections } from "react-icons/fa";
import { Link } from "react-router-dom";

import { GoogleMaps } from "../../../common/GoogleMaps/GoogleMaps";
import { useLearning } from "../hooks/useLearning";

export function CourseLocation() {
	const { course } = useLearning();

	const renderMap = () => {
		if (!course || course.latitude === null || course.longitude === null) {
			return null;
		}

		return (
			<GoogleMaps
				lat={course.latitude}
				lng={course.longitude}
				className="map item-separator-tiny"
			/>
		);
	};

	if (!course) {
		return null;
	}

	return (
		<div className="course-location-container item-separator-big">
			<Typography className="normal-text bold">Location</Typography>
			<div style={{ display: "flex", alignItems: "center" }}>
				<Typography className="normal-text" component="div" flex={1}>
					{course.location}
				</Typography>
				<Tooltip title="Click for directions">
					<Link
						to={`https://www.google.com/maps/dir/?api=1&destination=${course.latitude},${course.longitude}`}
						target="_blank">
						<IconButton className="icon-button">
							<FaDirections />
						</IconButton>
					</Link>
				</Tooltip>
			</div>
			{renderMap()}
		</div>
	);
}
